export const BANKRUPTCY_STATUSES = {
  draft: 'DRAFT',
  enqueued: 'ENQUEUED',
  screening: 'SCREENING',
  new: 'NEW',
  converted: 'CONVERTED',
  dismissed: 'DISMISSED',
  failed: 'FAILED',
} as const

// The case is mid-screen: queued or running. The screen button waits and the badge animates.
export const BANKRUPTCY_SCREENING_STATUSES: string[] = [
  BANKRUPTCY_STATUSES.enqueued,
  BANKRUPTCY_STATUSES.screening,
]
